import React from 'react'
import PropTypes from 'prop-types'
import ReferralInfo from './ReferralInfo'
import ContentImageSection from './ContentImageSection'

export default function LandingPageReferrals({ referralData }) {
  const {
    content_image_sections,
    translations,
    user_data,
    user_is_referrer,
    user_logged_in,
  } = referralData

  return (
    <>
      {(!user_logged_in || !user_is_referrer) && (
        content_image_sections.map((cis) => <ContentImageSection section={cis} key={cis.node_id} />)
      )}

      {user_is_referrer && (
        <div className="container contentWrapper_large">
          <ReferralInfo translations={translations} userData={user_data} />
        </div>
      )}
    </>
  )
}

LandingPageReferrals.propTypes = {
  referralData: PropTypes.shape({
    content_image_sections: PropTypes.array.isRequired,
    translations: PropTypes.object.isRequired,
    user_data: PropTypes.object.isRequired,
    user_is_referrer: PropTypes.bool.isRequired,
    user_logged_in: PropTypes.bool.isRequired,
  }).isRequired,
}
